import { render } from "./AdminDossier.vue?vue&type=template&id=392bddc2"
import script from "./AdminDossier.vue?vue&type=script&lang=js"
export * from "./AdminDossier.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__